import { useLocation } from "react-router-dom";
import WarehouseInWardActionV2 from "../../WarehouseInwardNew/pages/WarehouseInWardActionV2";
import ReturnInwardPage from "../ReturnInwardPage";
import type { ReturnSourceType } from "../config/returnKinds";
import { resolveInwardRoute } from "./resolveInwardRoute";

/**
 * Điểm vào chung của 3 URL create/edit/detail-warehouse-in-ward.
 * Giữ nguyên URL để các màn đang điều hướng vào, phân quyền menu và breadcrumb vẫn chạy.
 * Phiếu nhập đổi trả (NHAP_DOI_TRA) mở ReturnInwardPage; các loại khác vẫn mở trang cũ.
 * Muốn quay lại trang cũ cho nhập đổi trả: bỏ nhánh route.isReturn.
 */
const InwardActionDispatcher = () => {
  const location = useLocation();
  const route = resolveInwardRoute({
    pathname: location.pathname,
    state: location.state,
    search: location.search,
  });

  if (route.isReturn && route.sourceType) {
    // key: đổi phiếu hoặc chế độ thì dựng lại trang với state mới
    const key = [route.action, route.sourceType, route.id, route.sourceCode].join("|");
    return <ReturnInwardPage key={key} route={route} sourceType={route.sourceType as ReturnSourceType} />;
  }
  return <WarehouseInWardActionV2 />;
};

export default InwardActionDispatcher;
